module.exports = __webpack_public_path__ + "img/groupe-24.dc18a9f3.svg";